// extracted by mini-css-extract-plugin
module.exports = {"hide-arrows":"EAN_hide-arrows__x4YE_"};